import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "wide9": "start-page-de2469fd-wide9-WXUgJq",
  "xwideOffset8": "start-page-de2469fd-xwideOffset8-WXUgJq",
  "armstrongGridContainer": "start-page-de2469fd-armstrongGridContainer-WXUgJq",
  "tinyOffset11": "start-page-de2469fd-tinyOffset11-WXUgJq",
  "wideOffset0": "start-page-de2469fd-wideOffset0-WXUgJq",
  "confinedOffset10": "start-page-de2469fd-confinedOffset10-WXUgJq",
  "row": "start-page-de2469fd-row-WXUgJq",
  "confined0": "start-page-de2469fd-confined0-WXUgJq",
  "wide10": "start-page-de2469fd-wide10-WXUgJq",
  "defaultOffset10": "start-page-de2469fd-defaultOffset10-WXUgJq",
  "tiny12": "start-page-de2469fd-tiny12-WXUgJq",
  "defaultOffset11": "start-page-de2469fd-defaultOffset11-WXUgJq",
  "tinyOffset6": "start-page-de2469fd-tinyOffset6-WXUgJq",
  "col": "start-page-de2469fd-col-WXUgJq",
  "tinyOffset1": "start-page-de2469fd-tinyOffset1-WXUgJq",
  "wide6": "start-page-de2469fd-wide6-WXUgJq",
  "xwideOffset2": "start-page-de2469fd-xwideOffset2-WXUgJq",
  "defaultOffset5": "start-page-de2469fd-defaultOffset5-WXUgJq",
  "xwideOffset1": "start-page-de2469fd-xwideOffset1-WXUgJq",
  "tiny1": "start-page-de2469fd-tiny1-WXUgJq",
  "confined2": "start-page-de2469fd-confined2-WXUgJq",
  "confinedOffset3": "start-page-de2469fd-confinedOffset3-WXUgJq",
  "wideOffset2": "start-page-de2469fd-wideOffset2-WXUgJq",
  "xwide5": "start-page-de2469fd-xwide5-WXUgJq",
  "default4": "start-page-de2469fd-default4-WXUgJq",
  "tinyOffset4": "start-page-de2469fd-tinyOffset4-WXUgJq",
  "xwide10": "start-page-de2469fd-xwide10-WXUgJq",
  "confinedOffset5": "start-page-de2469fd-confinedOffset5-WXUgJq",
  "tiny11": "start-page-de2469fd-tiny11-WXUgJq",
  "wide2": "start-page-de2469fd-wide2-WXUgJq",
  "wide11": "start-page-de2469fd-wide11-WXUgJq",
  "standardGridContainer": "start-page-de2469fd-standardGridContainer-WXUgJq",
  "wideOffset10": "start-page-de2469fd-wideOffset10-WXUgJq",
  "xwide7": "start-page-de2469fd-xwide7-WXUgJq",
  "tinyOffset8": "start-page-de2469fd-tinyOffset8-WXUgJq",
  "wideOffset7": "start-page-de2469fd-wideOffset7-WXUgJq",
  "default11": "start-page-de2469fd-default11-WXUgJq",
  "confinedOffset2": "start-page-de2469fd-confinedOffset2-WXUgJq",
  "wide8": "start-page-de2469fd-wide8-WXUgJq",
  "xwideOffset6": "start-page-de2469fd-xwideOffset6-WXUgJq",
  "xwide11": "start-page-de2469fd-xwide11-WXUgJq",
  "tiny2": "start-page-de2469fd-tiny2-WXUgJq",
  "tiny4": "start-page-de2469fd-tiny4-WXUgJq",
  "wideOffset3": "start-page-de2469fd-wideOffset3-WXUgJq",
  "confined4": "start-page-de2469fd-confined4-WXUgJq",
  "wide1": "start-page-de2469fd-wide1-WXUgJq",
  "xwideOffset4": "start-page-de2469fd-xwideOffset4-WXUgJq",
  "xwide4": "start-page-de2469fd-xwide4-WXUgJq",
  "tinyOffset7": "start-page-de2469fd-tinyOffset7-WXUgJq",
  "defaultOffset9": "start-page-de2469fd-defaultOffset9-WXUgJq",
  "default2": "start-page-de2469fd-default2-WXUgJq",
  "default7": "start-page-de2469fd-default7-WXUgJq",
  "tiny3": "start-page-de2469fd-tiny3-WXUgJq",
  "default6": "start-page-de2469fd-default6-WXUgJq",
  "xwideOffset7": "start-page-de2469fd-xwideOffset7-WXUgJq",
  "default12": "start-page-de2469fd-default12-WXUgJq",
  "tinyOffset3": "start-page-de2469fd-tinyOffset3-WXUgJq",
  "xwideOffset9": "start-page-de2469fd-xwideOffset9-WXUgJq",
  "wide12": "start-page-de2469fd-wide12-WXUgJq",
  "gridContainer": "start-page-de2469fd-gridContainer-WXUgJq",
  "tiny9": "start-page-de2469fd-tiny9-WXUgJq",
  "confined1": "start-page-de2469fd-confined1-WXUgJq",
  "confinedOffset0": "start-page-de2469fd-confinedOffset0-WXUgJq",
  "xwide3": "start-page-de2469fd-xwide3-WXUgJq",
  "xwideOffset5": "start-page-de2469fd-xwideOffset5-WXUgJq",
  "default9": "start-page-de2469fd-default9-WXUgJq",
  "confined5": "start-page-de2469fd-confined5-WXUgJq",
  "tiny7": "start-page-de2469fd-tiny7-WXUgJq",
  "xwide6": "start-page-de2469fd-xwide6-WXUgJq",
  "confinedOffset7": "start-page-de2469fd-confinedOffset7-WXUgJq",
  "confinedOffset1": "start-page-de2469fd-confinedOffset1-WXUgJq",
  "defaultOffset6": "start-page-de2469fd-defaultOffset6-WXUgJq",
  "tiny5": "start-page-de2469fd-tiny5-WXUgJq",
  "wide7": "start-page-de2469fd-wide7-WXUgJq",
  "xwide8": "start-page-de2469fd-xwide8-WXUgJq",
  "defaultOffset7": "start-page-de2469fd-defaultOffset7-WXUgJq",
  "xwide0": "start-page-de2469fd-xwide0-WXUgJq",
  "tiny10": "start-page-de2469fd-tiny10-WXUgJq",
  "wide5": "start-page-de2469fd-wide5-WXUgJq",
  "xwide9": "start-page-de2469fd-xwide9-WXUgJq",
  "defaultOffset3": "start-page-de2469fd-defaultOffset3-WXUgJq",
  "confined8": "start-page-de2469fd-confined8-WXUgJq",
  "wideGridContainer": "start-page-de2469fd-wideGridContainer-WXUgJq",
  "tinyOffset9": "start-page-de2469fd-tinyOffset9-WXUgJq",
  "tiny6": "start-page-de2469fd-tiny6-WXUgJq",
  "defaultOffset2": "start-page-de2469fd-defaultOffset2-WXUgJq",
  "tinyOffset5": "start-page-de2469fd-tinyOffset5-WXUgJq",
  "confinedOffset6": "start-page-de2469fd-confinedOffset6-WXUgJq",
  "wideOffset11": "start-page-de2469fd-wideOffset11-WXUgJq",
  "xwideOffset11": "start-page-de2469fd-xwideOffset11-WXUgJq",
  "default10": "start-page-de2469fd-default10-WXUgJq",
  "confined12": "start-page-de2469fd-confined12-WXUgJq",
  "confinedOffset8": "start-page-de2469fd-confinedOffset8-WXUgJq",
  "default1": "start-page-de2469fd-default1-WXUgJq",
  "confinedOffset9": "start-page-de2469fd-confinedOffset9-WXUgJq",
  "xwideOffset0": "start-page-de2469fd-xwideOffset0-WXUgJq",
  "grid": "start-page-de2469fd-grid-WXUgJq",
  "defaultOffset8": "start-page-de2469fd-defaultOffset8-WXUgJq",
  "xwideOffset3": "start-page-de2469fd-xwideOffset3-WXUgJq",
  "tinyOffset0": "start-page-de2469fd-tinyOffset0-WXUgJq",
  "default0": "start-page-de2469fd-default0-WXUgJq",
  "wideOffset5": "start-page-de2469fd-wideOffset5-WXUgJq",
  "wideOffset8": "start-page-de2469fd-wideOffset8-WXUgJq",
  "xwide1": "start-page-de2469fd-xwide1-WXUgJq",
  "confined9": "start-page-de2469fd-confined9-WXUgJq",
  "defaultOffset1": "start-page-de2469fd-defaultOffset1-WXUgJq",
  "confinedOffset11": "start-page-de2469fd-confinedOffset11-WXUgJq",
  "default3": "start-page-de2469fd-default3-WXUgJq",
  "tinyOffset10": "start-page-de2469fd-tinyOffset10-WXUgJq",
  "wide3": "start-page-de2469fd-wide3-WXUgJq",
  "wide4": "start-page-de2469fd-wide4-WXUgJq",
  "xwide2": "start-page-de2469fd-xwide2-WXUgJq",
  "wideOffset1": "start-page-de2469fd-wideOffset1-WXUgJq",
  "confined7": "start-page-de2469fd-confined7-WXUgJq",
  "confined6": "start-page-de2469fd-confined6-WXUgJq",
  "wideOffset4": "start-page-de2469fd-wideOffset4-WXUgJq",
  "confinedOffset4": "start-page-de2469fd-confinedOffset4-WXUgJq",
  "confined11": "start-page-de2469fd-confined11-WXUgJq",
  "wideOffset6": "start-page-de2469fd-wideOffset6-WXUgJq",
  "wideOffset9": "start-page-de2469fd-wideOffset9-WXUgJq",
  "defaultOffset4": "start-page-de2469fd-defaultOffset4-WXUgJq",
  "default8": "start-page-de2469fd-default8-WXUgJq",
  "xwide12": "start-page-de2469fd-xwide12-WXUgJq",
  "tiny8": "start-page-de2469fd-tiny8-WXUgJq",
  "xwideOffset10": "start-page-de2469fd-xwideOffset10-WXUgJq",
  "tiny0": "start-page-de2469fd-tiny0-WXUgJq",
  "tinyOffset2": "start-page-de2469fd-tinyOffset2-WXUgJq",
  "default5": "start-page-de2469fd-default5-WXUgJq",
  "confined3": "start-page-de2469fd-confined3-WXUgJq",
  "confined10": "start-page-de2469fd-confined10-WXUgJq",
  "wide0": "start-page-de2469fd-wide0-WXUgJq"
};